import { FlashIcon, GridIcon, LoginIcon, SearchIcon, UserIcon } from './Icons';
import './ActionButtons.css';

interface Props {
  onQuickSearch: () => void;
  onLogin: () => void;
  isAuthenticated: boolean;
  userName?: string;
}

export default function ActionButtons({ onQuickSearch, onLogin, isAuthenticated, userName }: Props) {
  return (
    <div className="action-buttons section-shell">
      <button className="action-btn action-btn--catalog" type="button">
        <GridIcon size={22} />
        <span>Catálogo</span>
        <small>Ofertas e giro do dia</small>
      </button>
      <button className="action-btn action-btn--quick-order" type="button">
        <FlashIcon size={22} />
        <span>Ofertas do dia</span>
        <small>Reposição com agilidade</small>
      </button>
      <button className="action-btn action-btn--search" onClick={onQuickSearch} type="button">
        <SearchIcon size={22} />
        <span>Consulta rápida</span>
        <small>Busque por nome ou código</small>
      </button>
      {isAuthenticated ? (
        <div className="action-btn action-btn--user" aria-label={`Conta de ${userName || 'cliente'}`}>
          <UserIcon size={22} />
          <span className="action-btn-user-text">{userName || 'Conta ativa'}</span>
          <small>Área do cliente</small>
        </div>
      ) : (
        <button className="action-btn action-btn--login" onClick={onLogin} type="button">
          <LoginIcon size={22} />
          <span>Entrar</span>
          <small>Preço, pedido e histórico</small>
        </button>
      )}
    </div>
  );
}
